import React, { useContext, useEffect } from "react";
import MapContext from "../context/MapContext";

// popout that shows the location details
// only appears when a user clicks on a pin or a menu-item

const LocationPopout = () => {
	const {
		data: { showPopout, selectedLocation: location },
		actions: { closePopout },
	} = useContext(MapContext);

	useEffect(() => {
		const handleKeydown = (e) => {
			if (e.key === "Escape") closePopout();
		};
		if (showPopout) {
			document.addEventListener("keydown", handleKeydown);
		}
		return () => {
			document.removeEventListener("keydown", handleKeydown);
		};
	}, [location]);

	if (!location.name) return null;

	const renderImage = () => {
		if (!location || !location?.img) return null;

		return (
			<div className="location-popout__image__aspect-ratio">
				<img
					className="location-popout__image"
					src={location.img}
					alt={location.imgAlt}
				/>
			</div>
		);
	};
	const renderDetails = () => {
		if (!location || !location?.details) return null;
		return <div dangerouslySetInnerHTML={{ __html: location.details }}></div>;
	};
	const renderLink = () => {
		if (!location || !location.link) return null;

		return (
			<a
				className="location-popout__link"
				tabIndex={showPopout ? 1 : -1}
				href={location.link}
				target="_blank" rel="noreferrer"
			>
				See more
			</a>
		);
	};

	const isNumber = Number.isInteger(+location.display);
	const displayNumber = isNumber && location.display;

	return (
		<div className={`location-popout ${showPopout ? "show" : ""}`}>
			<button
				tabIndex={showPopout ? 1 : -1}
				className="location-popout__btn"
				onClick={() => closePopout()}
				aria-label="close details panel"
			></button>
			<div className="location-popout__title-container">
				<div
					className={`location-popout__title-container__pin icon-${location?.display} highlight`}
				>
					{displayNumber}
				</div>
				{location && <h5 dangerouslySetInnerHTML={{ __html: location.name }} className="location-popout__title-container__title"/>}
			</div>
			{renderImage()}
			{renderDetails()}
			{renderLink()}
		</div>
	);
};

export default LocationPopout;
